import { useStore } from '@/store';
import { AUTH_ACTION } from '@/store/actions/actionTypes';
import { LoginPayload } from '@/store/actions/auth';
import { User } from '../types/entities/User';

export const useUser = () => {
  const { getters, dispatch } = useStore();
  const user: User = getters.user;

  const login = async (payload: LoginPayload) => {
    dispatch(AUTH_ACTION.LOGIN, payload);
  };

  const logout = async () => {
    dispatch(AUTH_ACTION.LOGOUT);
  };

  return { user, login, logout };
};
